/**
 * @generated SignedSource<<2d2fe0965ef8725c87ad40542d4433ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumnOld_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_query" | "BoardInlineCreate_query" | "BoardTransitionZonesOld_query">;
  readonly " $fragmentType": "BoardColumnOld_query";
};
export type BoardColumnOld_query$key = {
  readonly " $data"?: BoardColumnOld_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumnOld_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardInlineCreate_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardTransitionZonesOld_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "c8e11075da53001629d1cd86ec557d18";

export default node;
